import { Container, Box, Card, CardContent, Stack, Skeleton, Divider } from '@mui/material';

export const ClusterInstallationsAddSkeleton = () => (
  <Container maxWidth="xl" sx={{ py: 4, px: 3, minHeight: '100vh' }}>
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" sx={{ fontSize: '2.125rem' }} width="40%" />
      </Stack>
    </Box>

    <Box sx={{ mt: 3 }}>
      <Skeleton variant="text" sx={{ fontSize: '1rem', mb: 3 }} width="60%" />

      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: 3 }}>
          <Stack spacing={2}>
            {[...Array(3)].map((_, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="30%" sx={{ mb: 1 }} />
                  <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 1 }} />
                </Box>
                <Skeleton variant="circular" width={40} height={40} sx={{ flexShrink: 0 }} />
              </Box>
            ))}

            <Skeleton
              variant="rectangular"
              width={180}
              height={36}
              sx={{ alignSelf: 'flex-start', mt: 2, borderRadius: 1 }}
            />
          </Stack>

          <Divider sx={{ my: 3 }} />

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={130} height={36} sx={{ borderRadius: 1 }} />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  </Container>
);
